import { type FragmentOf, graphql, readFragment } from "@/graphql"

const YEARLY_BILLING_FREQUENCY = 12

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementYearlyBillingFrequency_Agreement on AgreementType {
            billingFrequency
        }
    `),
}

type IsAgreementYearlyBillingFrequencyProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

export function isAgreementYearlyBillingFrequency(props: IsAgreementYearlyBillingFrequencyProps) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    return agreement.billingFrequency === YEARLY_BILLING_FREQUENCY
}

isAgreementYearlyBillingFrequency.fragments = graphQLFragments
